import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {BaseResponse} from '../../shared/models/respose/BaseResponse';
import {Order} from '../../shared/models/Order';
import {PaginatedDataResponse} from '../../shared/models/respose/PaginatedDataResponse';
import {PaginatedDataRequest} from '../../shared/models/request/PaginatedDataRequest';
import {map} from 'rxjs/operators';
import {ExportService} from './export.service';
import {Project} from '../../shared/models/Project';
import {ProjectRequest} from '../models/request/ProjectRequest';

@Injectable({
  providedIn: 'root'
})
export class ProjectService extends ExportService<ProjectRequest> {

  exportPath = 'projects';

  getPaginatedList(entries: number,
                   page: number,
                   data?: Project | ProjectRequest,
                   order?: Order): Observable<BaseResponse<PaginatedDataResponse<Project>>> {
    const request = new PaginatedDataRequest<Project | ProjectRequest>(entries, page, data, order);
    return this.post('projects', request).pipe(
      map(response => {
        return response;
      })
    );
  }

  register(request: Project): Observable<BaseResponse<Project>> {
    return this.post('projects/store', request);
  }

  exportGantt(request: any): Observable<Blob> {
    return this.post('projects/gantt', request, 'blob');
  }

  exportMexal(request: any): Observable<Blob> {
    return this.post('projects/mexal', request, 'blob');
  }

  deleteItem(id: number): Observable<BaseResponse<Project>> {
    return this.delete('projects', id);
  }

  updateItem(request: Project, id: number): Observable<BaseResponse<Project>> {
    return this.put('projects', request, id);
  }

  getItem(id: number): Observable<BaseResponse<Project>> {
    return this.get('projects/' + id);
  }

  exportHours(request: any): Observable<Blob> {
    return this.post('projects/export_hours', request, 'blob');
  }

}
